import { store } from '../store'
import { isMovieSelector } from '../selectors/detailFragment'
import { refreshMainActionBox, refreshEpisode, refreshBtfActionBoxes } from './wps'


export const refreshActionBoxes = (titleId?: string) => {
  const state = store.getState()
  const { pageTitleId } = state

  const promises = [
    refreshMainActionBox(state.pageTitleId, Boolean(state.features.isElcano))
  ]
  if (!isMovieSelector(state)) {
      promises.push(
        titleId ? refreshEpisode(titleId) : refreshBtfActionBoxes(pageTitleId)
      )
  }

  return Promise.all(promises)
}